import React from 'react';
import css from './index.module.scss';
import csx from 'classnames';

interface LogoProps {
  invert?: boolean;
}

export const Logo = (props: LogoProps) => (
  <span
    className={csx(css.container, { [css.invert]: props.invert })}
  >
    AL.
  </span>
);
